import React from 'react'
import { NavLink } from 'react-router-dom';

function MainButton({path, title, status}) {
    /* to="/Contact" */
  return (
    <>
        <NavLink className="col-hero-3 section1__button" exact to={path}>
            <div className="inner__button"></div> 
            <span className="button_Placeholder">{title}</span>
        </NavLink>
    </>
  )
}

export default MainButton